import type { MfaChallenge } from "@/lib/auth/auth-api";

const MFA_CHALLENGE_STORAGE_KEY = "ashtra_mfa_login_challenge";

export type StoredMfaChallenge = Pick<MfaChallenge, "challenge" | "isTrustedDevice">;

function getSessionStorage(): Storage | null {
  if (typeof window === "undefined") return null;
  try {
    return window.sessionStorage;
  } catch {
    return null;
  }
}

export function readStoredMfaChallenge(): StoredMfaChallenge | null {
  const storage = getSessionStorage();
  if (!storage) return null;
  try {
    const parsed: unknown = JSON.parse(
      storage.getItem(MFA_CHALLENGE_STORAGE_KEY) ?? "null",
    );
    if (
      typeof parsed !== "object" ||
      parsed === null ||
      typeof (parsed as { challenge?: unknown }).challenge !== "string" ||
      typeof (parsed as { isTrustedDevice?: unknown }).isTrustedDevice !== "boolean"
    ) {
      return null;
    }
    return parsed as StoredMfaChallenge;
  } catch {
    return null;
  }
}

export function hasStoredMfaChallenge(): boolean {
  return readStoredMfaChallenge() !== null;
}

export function storeMfaChallenge(challenge: StoredMfaChallenge): void {
  try {
    getSessionStorage()?.setItem(MFA_CHALLENGE_STORAGE_KEY, JSON.stringify(challenge));
  } catch {
    // A storage failure must not block MFA verification in the current tab.
  }
}

export function clearStoredMfaChallenge(): void {
  try {
    getSessionStorage()?.removeItem(MFA_CHALLENGE_STORAGE_KEY);
  } catch {
    // Best effort; the challenge will expire server-side.
  }
}
